/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Directive, TemplateRef } from "@angular/core";
var WizardPageHeaderActionsDirective = (function () {
    function WizardPageHeaderActionsDirective(pageHeaderActionsTemplateRef) {
        this.pageHeaderActionsTemplateRef = pageHeaderActionsTemplateRef;
    }
    return WizardPageHeaderActionsDirective;
}());
export { WizardPageHeaderActionsDirective };
WizardPageHeaderActionsDirective.decorators = [
    { type: Directive, args: [{
                selector: "[clrPageHeaderActions]"
            },] },
];
/** @nocollapse */
WizardPageHeaderActionsDirective.ctorParameters = function () { return [
    { type: TemplateRef, },
]; };
//# sourceMappingURL=page-header-actions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/wizard/directives/page-header-actions.js
// module id = 98
// module chunks = 4